import { render, staticRenderFns } from "./LearningGoalSelection.vue?vue&type=template&id=e6f1be44&"
import script from "./LearningGoalSelection.vue?vue&type=script&lang=js&"
export * from "./LearningGoalSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports